const ZERO_WIDTH_CHARS_REGEX = /[\u200B-\u200D\uFEFF]/g;
const NON_BREAKING_SPACE_REGEX = /\u00A0/g;
const UNICODE_NORMALIZATION_FORM = 'NFKC';

export const sanitizeAndNormalizeEmail = (value?: string) =>
	(value ?? '')
		.normalize(UNICODE_NORMALIZATION_FORM)
		.replace(ZERO_WIDTH_CHARS_REGEX, '')
		.replace(NON_BREAKING_SPACE_REGEX, ' ')
		.trim()
		.toLowerCase();
